import { CanUsesInitialBudgets } from 'src/components/guards/PermissionsList';

const selfPermissions = [
  'DeleteInvoicesOwn',
  'CloseOfflinePoOwned',
  'ClosePoOwned',
  'CancelPOSelf',
  'CompleteReceipts',
  'CanReceiveInvoices',
  'ReceivePoOwned',
];

export const companyAttributes = [...CanUsesInitialBudgets];

export default selfPermissions;
